import api from "@/services/api";

const state = {
  list: [],
  pending: {
    totalPendingAmount: 0,
    pendingCount: 0,
  },
  dueToday: {
    totalDueAmount: 0,
    dueCount: 0,
    invoices: [],
  },
  overdue: {
    totalOverdueAmount: 0,
    overdueCount: 0,
    invoices: [],
  }
};

const mutations = {
  SET_INVOICES(state, invoices) {
    state.list = invoices;
  },
  SET_PENDING_BALANCE(state, data) {
    state.pending = data;
  },
  DUE_TODAY(state, data) {
    state.dueToday = data;
  },
  SET_OVERDUE(state, data) {
    state.overdue = data;
  }
};

const actions = {
  // ================= CREATE =================
  async CreateInvoice(_, payload) {
    try {
      let res = await api.post("/invoices", payload);
      return res.data;
    } catch (error) {
      console.error("Error creating invoice:", error.message);
      throw error;
    }
  },

  // ================= GET ALL =================
  async getInvoices({ commit }) {
    try {
      const res = await api.get("/invoices");
      commit("SET_INVOICES", res.data);
    } catch (error) {
      console.error("Error fetching invoices:", error.message);
      throw error;
    }
  },

  // ================= GET BY ID =================
  async getInvoiceById(_, id) {
    try {
      const res = await api.get(`/invoices/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching invoice:", error.message);
      throw error;
    }
  },

  // ================= UPDATE =================
  async UpdateInvoice(_, payload) {
    try {
      const id = payload.id;
      const res = await api.put(`/invoices/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("Error updating invoice:", error.message);
      throw error;
    }
  },

  // ================= DELETE =================
  async DeleteInvoice(_, id) {
    try {
      const res = await api.delete(`/invoices/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error deleting invoice:", error.message);
      throw error;
    }
  },

  // ================= MARK AS PAID =================
  async markInvoiceAsPaid(_, payload) {
    try {
      const res = await api.put(`/invoices/${payload.id}/mark-paid`, payload);
      return res.data;
    } catch (error) {
      console.error("Error marking invoice as paid:", error.message);
      throw error;
    }
  },

  // ================= PENDING AMOUNT =================
  async getPendingAmount({ commit }) {
    try {
      const res = await api.get("/invoices/pending-amount");
      commit("SET_PENDING_BALANCE", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching pending amount:", error.message);
      throw error;
    }
  },

  async getTodayDueSummary({ commit }) {
    try {
      const res = await api.get("/invoices/due-today");
      commit("DUE_TODAY", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching today's due summary:", error.message);
      throw error;
    }
  },

  async getOverdueSummary({ commit }) {
    try {
      const res = await api.get("/invoices/overdue");
      commit("SET_OVERDUE", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching overdue summary:", error.message);
      throw error;
    }
  },

  async getNextInvoiceNumber() {
    try {
      const res = await api.get("/invoices/next-invoice-number");
      return res.data.nextInvoiceNumber;
    } catch (error) {
      console.error("Error fetching next invoice number:", error.message);
      throw error;
    }
  },

  async downloadInvoiceFile(_, fileKey) {
  try {
    const url = `/invoices/download/${encodeURIComponent(fileKey)}`;

    const response = await api.get(url, {
      responseType: "blob",
    });

    return response;
  } catch (error) {
    console.error("Error downloading invoice file:", error.message);
    throw error;
  }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};